import styled from 'styled-components';

export default styled.img`
  width: 100%;
  background-color: #f2f2f2;
`;